import { render, staticRenderFns } from "./VueCropper.vue?vue&type=template&id=97739562&scoped=true"
import script from "./VueCropper.vue?vue&type=script&lang=js"
export * from "./VueCropper.vue?vue&type=script&lang=js"
import style0 from "./VueCropper.vue?vue&type=style&index=0&id=97739562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97739562",
  null
  
)

export default component.exports